export type DashboardStatusOption = {
  value: string;
  label: string;
};

const SHARED_STATUS_OPTIONS: DashboardStatusOption[] = [
  { value: 'aberto', label: 'Aberto' },
  { value: 'em_andamento', label: 'Em Andamento' },
  { value: 'aguardando_informacao_usuario', label: 'Aguardando Informação do Usuário' },
  { value: 'aguardando_terceiros', label: 'Aguardando Terceiros' },
  { value: 'aguardando_evidencia', label: 'Aguardando Evidência' },
  { value: 'aguardando_problema', label: 'Aguardando Problema' },
  { value: 'aguardando_implantacao', label: 'Aguardando Implantação' },
];

const PURCHASE_STATUS_OPTIONS: DashboardStatusOption[] = [
  { value: 'aguardando_aprovacao', label: 'Aguardando Aprovação' },
  { value: 'aguardando_reenvio', label: 'Aguardando Reenvio' },
];

const FINAL_STATUS_OPTIONS: DashboardStatusOption[] = [
  { value: 'resolvido', label: 'Resolvido' },
  { value: 'cancelado', label: 'Cancelado' },
  { value: 'fechado', label: 'Fechado' },
];

export function dashboardStatusOptions(area: string): DashboardStatusOption[] {
  if (area === 'purchases') {
    return [...SHARED_STATUS_OPTIONS, ...PURCHASE_STATUS_OPTIONS, ...FINAL_STATUS_OPTIONS];
  }
  return [...SHARED_STATUS_OPTIONS, ...FINAL_STATUS_OPTIONS];
}

/** Lê `statuses` repetidos na query; fallback para `status` legado. */
export function parseStatusesFromSearchParams(params: URLSearchParams): string[] {
  const fromMany = params
    .getAll('statuses')
    .map((value) => value.trim())
    .filter(Boolean);
  if (fromMany.length > 0) return fromMany;
  const legacy = params.get('status')?.trim();
  return legacy ? [legacy] : [];
}

export function restoreDashboardStatuses(restored: { filterStatuses?: unknown; filterStatus?: unknown } | null): string[] {
  if (!restored) return [];
  if (Array.isArray(restored.filterStatuses)) {
    return restored.filterStatuses.filter((value): value is string => typeof value === 'string' && value.trim() !== '');
  }
  if (typeof restored.filterStatus === 'string' && restored.filterStatus.trim() !== '') {
    return [restored.filterStatus];
  }
  return [];
}

export function statusesForArea(area: string, selected: string[]): string[] {
  const allowed = new Set(dashboardStatusOptions(area).map((option) => option.value));
  return selected.filter((value) => allowed.has(value));
}

export function serializeDashboardParams(params: Record<string, unknown>): string {
  const search = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && String(item) !== '') {
          search.append(key, String(item));
        }
      });
      return;
    }
    search.append(key, String(value));
  });
  return search.toString();
}
